export default {
  ResloadingInventory: "Loading inventory...",
  ResrestaurantInventory: "Restaurant Inventory",
  ResrealTimeStock: "Real-time stock snapshot",

  RessearchProduct: "Search by product name...",

  Resall: "All",
  ResinStock: "In Stock",
  ReslowStock: "Low Stock",
  ResoutOfStock: "Out of Stock",

  RestotalProducts: "Total Products",
  RestotalQuantity: "Total Quantity",

  ResissueToKitchen: "Kitchen",
  Resreorder: "Reorder",

  Resquantity: "Quantity",
  Resremarks: "Remarks",
  Rescancel: "Cancel",
  Resissue: "Issue",
  Resissuing: "Issuing...",
  Resordering: "Ordering...",

  ResreorderProduct: "Reorder Product",
  RescurrentStock: "Current Stock",
};